var _defs, _polygon, _polyline, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcWitt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a2834;}.cls-2{fill:#dd3a3a;}.cls-3{fill:#33222e;}.cls-4{fill:#2d1f29;}.cls-5{fill:#4c3547;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.54 277.66 455.62 277.66 504.04 438.66 202.82 439.05 250.54 277.66"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "250.81 277.58 353.34 235.21 455.87 277.78"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "212.29 458.02 491.94 458.02 504.04 438.66 202.6 438.66 212.29 458.02"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "298.88 492.61 406.01 492.61 419.43 468.33 286.56 468.33 298.88 492.61"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "252.12 475.86 452.12 475.86 465.92 457.42 240.74 457.42 252.12 475.86"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "316.48 439.42 202.43 439.05 237.26 253.85 292.33 214.03 316.48 439.42"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "390.17 439.42 504.22 439.05 469.39 253.85 414.31 214.03 390.17 439.42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcWitt);
export default __webpack_public_path__ + "static/media/npc-witt.66f26746dc636ed44d6ab6016dd64dcf.svg";
export { ForwardRef as ReactComponent };